function mergeCartIconBubbleFromSectionHtml(htmlString, rootSelector) {
  const cartLink = document.getElementById("cart-icon-bubble");
  if (!cartLink || !htmlString) return false;
  const doc = new DOMParser().parseFromString(htmlString, "text/html");
  const root = rootSelector ? doc.querySelector(rootSelector) : doc.body;
  if (!root) return false;
  const newBubble = root.querySelector(".cart-count-bubble");
  const oldBubble = cartLink.querySelector(".cart-count-bubble");
  if (!newBubble || !oldBubble) return false;
  oldBubble.outerHTML = newBubble.outerHTML;
  return true;
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
    //this.addCloseButtonHandlers();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  addCloseButtonHandlers() {
    const closeDetails = (detailsElement) => {
      detailsElement?.removeAttribute("open");
    };

    const noteDetails = this.querySelector("#Details-CartDrawer");
    const noteCloseButton = this.querySelector("#cart_note-close");
    const applyButton = this.querySelector("#apply_button");

    if (noteDetails && noteCloseButton) {
      noteCloseButton.addEventListener("click", () =>
        closeDetails(noteDetails)
      );
    }
    if (noteDetails && applyButton) {
      applyButton.addEventListener("click", () => closeDetails(noteDetails));
    }

    const discountDetails = this.querySelector("#Details-CartDrawer-Discount");
    const discountCloseButton = this.querySelector("#cart_discount-close");

    if (discountDetails && discountCloseButton) {
      discountCloseButton.addEventListener("click", () =>
        closeDetails(discountDetails)
      );
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
      this.addCloseButtonHandlers();
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState.sections[section.id];
      if (
        section.id === "cart-icon-bubble" &&
        sectionHtml &&
        mergeCartIconBubbleFromSectionHtml(sectionHtml, ".shopify-section")
      ) {
        const cartLink = document.getElementById("cart-icon-bubble");
        if (cartLink && typeof parsedState.item_count === "number") {
          cartLink.classList.toggle(
            "header__cart--empt",
            parsedState.item_count === 0
          );
        }
        return;
      }
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

class CartUrgencyTimer extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.displayEl = this.querySelector("[data-urgency-display]");
    this.durationMs =
      (Number(this.dataset.durationMinutes) || 15) * 60 * 1000;
    this.storageKey = this.dataset.storageKey || "monochrome-cart-urgency-end";

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  getEndTime() {
    const stored = Number(sessionStorage.getItem(this.storageKey));
    const now = Date.now();

    if (stored && stored > now) {
      return stored;
    }

    const endTime = now + this.durationMs;
    sessionStorage.setItem(this.storageKey, String(endTime));
    return endTime;
  }

  tick() {
    let remaining = this.getEndTime() - Date.now();

    if (remaining <= 0) {
      sessionStorage.removeItem(this.storageKey);
      remaining = this.getEndTime() - Date.now();
    }

    const totalSeconds = Math.max(0, Math.ceil(remaining / 1000));
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    if (this.displayEl) {
      this.displayEl.textContent = `${String(minutes).padStart(2, "0")}:${String(
        seconds
      ).padStart(2, "0")}`;
    }
  }
}

if (!customElements.get("cart-urgency-timer")) {
  customElements.define("cart-urgency-timer", CartUrgencyTimer);
}
